import api from "./api";

import {
  CreateTranslationMemorySegmentRegexData,
  TranslationMemory,
  TranslationMemorySegmentRegex,
} from "../translation/types";

const SEGMENT_REGEX_BASE_URL =
  "/api/_internal/translation-memory-segment-regex/";
const TRANSLATION_MEMORY_BASE_URL = "/api/_internal/translation-memory/";

/**
 * Get all translation memory segment regex patterns
 */
export const getTranslationMemorySegmentRegexList = async (): Promise<
  TranslationMemorySegmentRegex[]
> => {
  const response = await api.get<TranslationMemorySegmentRegex[]>(
    SEGMENT_REGEX_BASE_URL,
    {}
  );
  return response.data;
};

/**
 * Get a single translation memory segment regex pattern by ID
 */
export const getTranslationMemorySegmentRegex = async (
  id: number
): Promise<TranslationMemorySegmentRegex> => {
  const response = await api.get<TranslationMemorySegmentRegex>(
    SEGMENT_REGEX_BASE_URL + id,
    {}
  );
  return response.data;
};

/**
 * Create a new translation memory segment regex pattern
 */
export const createTranslationMemorySegmentRegex = async (
  data: CreateTranslationMemorySegmentRegexData
): Promise<TranslationMemorySegmentRegex> => {
  const response = await api.post(SEGMENT_REGEX_BASE_URL, data, {});
  return response.data;
};

/**
 * Update an existing translation memory segment regex pattern
 * Currently unused
export const updateTranslationMemorySegmentRegex = async (
  id: number,
  data: UpdateTranslationMemorySegmentRegexData
): Promise<TranslationMemorySegmentRegex> => {
  const response = await api.put(SEGMENT_REGEX_BASE_URL + id, data, {});
  return response.data;
};
*/

/**
 * Delete a translation memory segment regex pattern
 * Currently unused
export const deleteTranslationMemorySegmentRegex = async (
  id: number
): Promise<unknown> => {
  const response = await api.delete(SEGMENT_REGEX_BASE_URL + id, {});
  return response.data;
};
 */

/**
 * Search translation memory
 */
export const searchTranslationMemory = async (
  text: string,
  sourceLanguage: string | null,
  targetLanguage: string,
  byField: "source_text" | "target_text" = "source_text",
  skipIds: number[] = []
): Promise<TranslationMemory[]> => {
  if (
    (!sourceLanguage && byField === "source_text") ||
    !targetLanguage ||
    !text.trim()
  ) {
    return [];
  }
  const response = await api.post(
    TRANSLATION_MEMORY_BASE_URL + "fuzzy-search/",
    {
      text,
      source_language: sourceLanguage,
      target_language: targetLanguage,
      skip_ids: skipIds,
      by_field: byField,
    },
    {}
  );
  return response.data;
};

/**
 * Add a translation memory
 */
export const addTranslationMemory = async (
  sourceText: string,
  targetText: string,
  sourceLanguage: string,
  targetLanguage: string,
  customerId: number,
  translatorId: number,
  createdFromModel: string,
  createdFromModelId: number
): Promise<{ id: number }> => {
  const response = await api.post(
    TRANSLATION_MEMORY_BASE_URL + "add/",
    {
      source_text: sourceText,
      target_text: targetText,
      source_language: sourceLanguage,
      target_language: targetLanguage,
      customer_id: customerId,
      translator_id: translatorId,
      created_from_model: createdFromModel,
      created_from_model_id: createdFromModelId,
    },
    {}
  );
  return response.data;
};
